import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';

import { Contact } from 'src/app/entity/Contact';
import { ConfirmedDialogComponent } from 'src/app/shared/dialogs';
import { Prospect, Titre } from 'src/app/entity/prospect';
import { Client } from 'src/app/entity/exhibitor';
import { ContactService } from 'src/app/service/contact.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { TitreService } from 'src/app/service/titre.service';
import { FactureService } from 'src/app/service/facture.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';


@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit, OnDestroy {

  @Input() form: FormGroup;
  @Input() prospect: Prospect;
  @Input() selectedClient: Client;

  @Output()
  contactChanged: EventEmitter<any> = new EventEmitter<any>();

  dataSource = new MatTableDataSource();
  userId: number;
  showSave: boolean;
  ;
  selectedContact: Contact;
  positions: Titre[]
  positionsS: string[];
  isContactPrincipal: boolean;
  constructor(private contactService: ContactService,
    private factureService: FactureService,
    private dialog: MatDialog, private exhibitorService: ExhibitorService, private titreService: TitreService) {



  }





  ngOnInit() {
    this.selectedContact = this.selectedClient.contact;
    if (this.selectedContact) {
      this.contactService.selectContact(this.selectedContact)
      this.buildContactFormContact(this.selectedContact)

    }
    this.findContacts();
    this.form.valueChanges.subscribe(result => {
      this.showSave=true;
  this.editContact()

    })
    this.userId = +    localStorage.getItem('idUser');
  }
  editContact() {
    this.getContactFromForm();
    if (this.selectedContact && this.selectedContact.contactId) {
  //    console.log('edietttt');
      
      if (this.selectedContact.mail)
        this.selectedContact.mail = this.selectedContact.mail.trim()
      //console.log('this.form.value.typeContact' + this.form.value.typeContact);


      this.contactService.saveContact(this.selectedContact).subscribe(result => {
        this.selectedContact = result;
     console.log("ediiiit" +  this.selectedContact.mobile );
    this.emitChanged()
        this.findContacts();
      });

    }

  }
  busyEmit = false;
  emitChanged() {
 

    if (!this.busyEmit) {
      this.busyEmit = true;
      setTimeout(() => {
        this.busyEmit = false
        this.contactChanged.emit()
        console.log('this.contactChanged.emit');
      }, 2000);

    }




  }


  getContactFromForm() {
    if (this.form && this.selectedContact) {
      this.selectedContact.nom = this.form.value.nom;
      this.selectedContact.tel = this.form.value.tel;
      this.selectedContact.mail = this.form.value.mail;
      this.selectedContact.titres = this.form.value.titres;
      this.selectedContact.mobile = this.form.value.mobile;
      this.selectedContact.typeContact = this.form.value.typeContact;


    }


  }

  ngOnDestroy(): void {

  }



  buildContactFormContact(contact: Contact): void {
    this.form.patchValue({
      'nom': contact.nom,
      'mobile': contact.mobile,
      'tel': contact.tel,
      'mail': contact.mail,
      'titres': contact.titres,
      'typeContact': contact.typeContact,


    });
  }






  findContacts() {
    //console.log('this.prospect.prospectId' + this.prospect.prospectId);

    this.contactService.findContactsByProspect(this.prospect.prospectId).subscribe(data => {
      this.dataSource.data = data;
      this.showSave=false;
    })

  }

  select(contact: Contact) {

    this.contactService.getContact(contact.contactId).subscribe(result => {
      this.selectedContact = result;


      this.contactService.selectContact(this.selectedContact)
      this.buildContactFormContact(result);

    })


  }

  setAsPrincipal() {
    this.exhibitorService.affectContactExhibitor(this.selectedClient.idClient, this.selectedContact.contactId).subscribe(result => {


      this.createContractIfNotExiste();

    })
  }
  createContractIfNotExiste() {

    this.factureService.createContractIfNotExiste(this.selectedClient.idClient).subscribe(result => {

      location.reload(); if (result)
        this.factureService.nextInvoice(result);


    });
  }




  ajouterNouveau(isCarteVisite: boolean) {
    let contact = new Contact();
    contact.nom = "";


    if (isCarteVisite)
      contact.typeContact = "cartevisite";
    else
      contact.typeContact = "email";



    contact.prospectId = this.prospect;
    //console.log("isCarteVisite" + isCarteVisite);

    this.contactService.addContact(contact).subscribe(result => {
      //console.log("result" + JSON.stringify(result));
      this.select(result)
      this.findContacts();
    })
  }

  deleteContact(contact: Contact): void {
    // Create configuration for the dialog
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '200px';
    dialogConfig.width = '400px';
    dialogConfig.data = {
      title: `Delete  ${contact.nom}  `,
      message: 'Are you sure?'
    };

    const dialogRef = this.dialog.open(ConfirmedDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.emitChanged()
        this.contactService.deleteContact(contact).subscribe(result => {
          this.contactService.findContactsByProspect(contact.prospectId.prospectId).subscribe(result => {
            this.dataSource.data = result;
          })
        })
      }
    });
  }
  filterPositions(filter: string) {
    if (filter && filter.length > 0)
      this.titreService.getAllDesignation(filter).subscribe(result => {
        this.positions = result;
        this.positionsS = []

        this.positions.forEach(element => {
          this.positionsS.push(element.designation)
        });
      });
  }

  role(type: string): string {
    if ("signataire" === type)
      return "Signataire";
    else if ("gestionnaire" === type)
      return "Gestionnaire du dossier";
    else if ("cartevisite" === type)
      return "Carte Visite";
    else if ("email" === type)
      return "Email";

  }

}




